import { createRequest } from '@savgroup-front-common/core/services/request';

export const GET_PRODUCT_FULL_INFO = createRequest('GET_PRODUCT_FULL_INFO');
